<script setup>
import { computed } from "vue";

const props = defineProps({
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  meta: {
    type: Object,
    default: () => ({ total: 0, per_page: 25, current_page: 1 }),
  },
});

const emit = defineEmits(["page-change"]);

const columns = [
  {
    sorter: false,
  },
  {
    title: "Invoice",
    dataIndex: "invoice_no",
    key: "invoice_no",
    sorter: {
      compare: (a, b) =>
        a.invoice_no.toLowerCase() > b.invoice_no.toLowerCase() ? 1 : -1,
    },
  },
  {
    title: "Client Name",
    dataIndex: "client_name",
    key: "client_name",
    sorter: {
      compare: (a, b) =>
        a.client_name.toLowerCase() > b.client_name.toLowerCase() ? 1 : -1,
    },
  },
 
  {
    title: "Payment Type",
    dataIndex: "method",
    key: "method",
    sorter: {
      compare: (a, b) =>
        (a.method || "").toLowerCase() > (b.method || "").toLowerCase()
          ? 1
          : -1,
    },
  },
  {
    title: "Paid Date",
    dataIndex: "payment_date",
    key: "payment_date",
    sorter: {
      compare: (a, b) =>
        (a.payment_date || "") > (b.payment_date || "") ? 1 : -1,
    },
  },
  {
    title: "Paid Amount",
    dataIndex: "amount",
    key: "amount",
    sorter: {
      compare: (a, b) => Number(a.amount) - Number(b.amount),
    },
  },
];

const dataSource = computed(() =>
  (props.items || []).map((p) => ({
    key: p.id,
    id: p.id,
    invoice_id: p.invoice_id,
    invoice_no: p.invoice?.invoice_no || "",
    client_name: p.client?.name || "",
    client_email: p.client?.email || "-",
    method: p.method || "",
    payment_date: p.payment_date,
    amount: p.amount,
    avatar: p.client?.logo_url || "user-39.jpg", // fallback
    client_role: p.client?.designation || "",
  }))
);

function formatMoney(value) {
  const num = Number(value || 0);
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


const pagination = computed(() => ({
  current: props.meta.current_page || 1,
  pageSize: props.meta.per_page || 25,
  total: props.meta.total || dataSource.value.length,
  showSizeChanger: false,
  onChange: (page) => emit("page-change", page),
}));
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="dataSource"
    :row-selection="{ onChange() {}, onSelect() {}, onSelectAll() {} }"
    :loading="loading"
    :pagination="pagination"
  >
    <template #bodyCell="{ column, record }">
      <!-- Invoice link -->
      <template v-if="column.key === 'invoice_no'">
        <router-link
          :to="{
            name: 'sales.invoices.show',
            params: { id: record.invoice_id },
          }"
          class="link-info"
        >
          {{ record.invoice_no }}
        </router-link>
      </template>

      <!-- Client with avatar -->
      <template v-else-if="column.key === 'client_name'">
        <div class="d-flex align-items-center file-name-icon">
          <span class="avatar avatar-md avatar-rounded">
            <img
              :src="record.avatar"
              class="img-fluid"
              alt="img"
            />
          </span>
          <div class="ms-2">
            <h6 class="fw-medium mb-0">
              <a href="javascript:void(0);">{{ record.client_name }}</a>
            </h6>
            <span class="d-block mt-1">{{ record.client_email }}</span>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'amount'">

        <div>{{formatMoney(record.amount)}}</div>

      </template>

      <!-- Fallback to default rendering for other columns -->
    </template>
  </a-table>
</template>
